import { CalculationLog } from "../model/CalculationLog";
import { configuration } from "./Configuration";
import { fetchWithAccessToken } from "./SiteConfig-api";

export const getCalculationLog = (
  runIdentifier: string
): Promise<CalculationLog> => {
    return fetchWithAccessToken(`${configuration.SmartAPI}calculationlogs/${runIdentifier}`, 'SmartApi', {
        method: 'GET',
        credentials: 'include'
      }).then(function(response: Response) {
        if (response.status !== 200) {
          throw response.statusText
        }
        
        return response.text()
      }).then(json => JSON.parse(json))
}